import UsersService from '../../services/UsersService';
import RequestList from "../../services/RequestList";

const state = {
    sentRequestCount: 0,
    items : [],
    users: {}
}

const getters = {
    fetching(state) {
        return state.sentRequestCount > 0;
    },
    activeUsers(state){
        return state.items.filter(user => !user.disabled_at)
    }
}

const mutations = {
    SET_USERS(state, users) {
        let usersKeyById = {};

        users.forEach(user => {
            usersKeyById[user.id] = user;
        });

        state.users = usersKeyById;
        state.items = users;
    },
    INCREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount++;
    },
    DECREMENT_SENT_REQUEST_COUNT(state) {
        state.sentRequestCount--;
    }
}

const actions = {
    async fetchUsers({ commit }) {
        commit('INCREMENT_SENT_REQUEST_COUNT');

        try {
            let requestList = new RequestList();
            let {
                data
            } = await UsersService.compactList(requestList);
            commit('SET_USERS', data.value.users);
        } finally {
            commit('DECREMENT_SENT_REQUEST_COUNT');
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}